module.exports = __webpack_public_path__ + "img/banner-princiapal.1bd35668.svg";